import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { Title } from './components/Title.js';
import { jsx } from 'react/jsx-runtime';

function MainHeading(props) {
  return /*#__PURE__*/jsx(Title, _extends({
    appearance: "main",
    as: "h1"
  }, props));
}
function PageHeading(props) {
  return /*#__PURE__*/jsx(Title, _extends({
    appearance: "page",
    as: "h2"
  }, props));
}
function SectionHeading(props) {
  return /*#__PURE__*/jsx(Title, _extends({
    appearance: "section",
    as: "h3"
  }, props));
}
function SectionSubHeading(props) {
  return /*#__PURE__*/jsx(Title, _extends({
    appearance: "subsection",
    as: "h4"
  }, props));
}
function LabelHeading(props) {
  return /*#__PURE__*/jsx(Title, _extends({
    appearance: "label",
    as: "h4"
  }, props));
}

export { LabelHeading, MainHeading, PageHeading, SectionHeading, SectionSubHeading };
